import { Route, Navigate } from 'react-router-dom';
import { ESettingsState } from 'components/Settings/Settings.types';

import {
  SettingsView
} from 'components/Settings';
import PortalSettingsView from 'views/PortalSettings/SettingsView';

import { componentMap, settingsConfigMap } from './constants';
import { ERouteContext } from '../types';

export const getSharedSettingsRoutes = (context: ERouteContext) => {
  const SettingsViewComponent = context === ERouteContext.PORTAL ? PortalSettingsView : SettingsView;
  const { defaultTab, paths } = settingsConfigMap[context];
  return (
    <Route path="settings/*" element={<SettingsViewComponent context={context}/>}>
      <Route path="" element={<Navigate to={defaultTab} replace />} />
      {paths.map((path: ESettingsState) => {
        const Component = componentMap[path];
        if (!Component) return null;
        
        return (
          <Route 
            key={path} 
            path={path} 
            element={<Component />} 
          />
        );
      })}
    </Route>
  );
}; 